import React from "react";
import { Composition } from "remotion";
import { TechLaunch } from "./templates/TechLaunch/TechLaunch";
import { ProductLaunch } from "./templates/ProductLaunch/ProductLaunch";


export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id="TechLaunch"
        component={TechLaunch}
        durationInFrames={900}
        fps={30}
        width={1920}
        height={1080}
      />

      <Composition
        id="ProductLaunch"
        component={ProductLaunch}
        durationInFrames={390}
        fps={30}
        width={1920}
        height={1080}
      />
    </>
  );
};